import { CSSProperties } from 'react';

interface CompanyLogoProps {
  width?: string;
  height?: string;
  background?: string;
}

export const AppLogo = (props: CompanyLogoProps) => {
  const styles: CSSProperties = {};

  if (props.width) {
    styles.width = props.width;
  }

  if (props.height) {
    styles.height = props.height;
  }

  return (
    <div style={styles}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g stroke="#FFFFFF" strokeWidth="18">
          <path d="M20 79 L50 51 L80 79"></path>
          <path d="M28 59 L50 38 L72 59"></path>
          <path d="M37 39 L50 26 L63 39"></path>
        </g>
        <path d="M20 79 L50 51 L80 79" stroke="#26498D" strokeWidth="11"></path>
        <path d="M28 59 L50 38 L72 59" stroke="#64ADB3" strokeWidth="11"></path>
        <path d="M37 39 L50 26 L63 39" stroke="#96AF31" strokeWidth="11"></path>
      </svg>
    </div>
  );
};
